export const API_URL =
  import.meta.env.VITE_API_URL ||
  "https://vettconsult-backend-clean-193016570271.us-central1.run.app";
